import { render, staticRenderFns } from "./ButtonSecondaryBackward.vue?vue&type=template&id=7908b1f9&scoped=true"
import script from "./ButtonSecondaryBackward.vue?vue&type=script&lang=js"
export * from "./ButtonSecondaryBackward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908b1f9",
  null
  
)

export default component.exports